import {
  CognniAppSettings,
  EditionStr,
  isEditionHighEnough,
} from "@/common/models";

export const DEFAULT_APPS_SETTINGS = (
  userEdition: EditionStr
): {
  [key: string]: CognniAppSettings;
} => {
  return {
    contentLabel: {
      added: false,
      on: false,
      pined: false,
    },
    customLabel: {
      added: false,
      on: true,
      pined: false,
    },
    reports: {
      added: false,
      on: false,
      pined: false,
    },
    detection: {
      added: false,
      on: false,
      pined: false,
    },
    riskType: {
      added: false,
      on: false,
      pined: false,
    },
    topics: {
      added: isEditionHighEnough({
        minEdition: "standard",
        userEdition,
      }),
      on: isEditionHighEnough({
        minEdition: "standard",
        userEdition,
      }),
      pined: false,
    },
    csv: {
      added: isEditionHighEnough({
        minEdition: "standard",
        userEdition,
      }),
      on: isEditionHighEnough({
        minEdition: "standard",
        userEdition,
      }),
      pined: false,
    },
    filters: {
      added: isEditionHighEnough({
        minEdition: "standard",
        userEdition,
      }),
      on: isEditionHighEnough({
        minEdition: "standard",
        userEdition,
      }),
      pined: false,
    },
    mcasPolicies: {
      added: false,
      on: false,
      pined: false,
    },
    mip: {
      added: false,
      on: false,
      pined: false,
    },
    sentinel: {
      added: false,
      on: false,
      pined: false,
    },
    Auditlog: {
      added: true,
      on: true,
      pined: false,
    },
    Exchange: {
      added: true,
      on: true,
      pined: false,
    },
  };
};
